'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mightyFields = require('../../lib/mighty-fields');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FIELDS = {
  'file': { field: 'file', required: true, type: 'file' },
  'name': { field: 'name', label: 'File Name', required: true },
  'type': {
    field: 'type.id',
    label: 'Document Type',
    optionType: 'documentTypeOptions',
    required: true,
    type: 'optionSelect'
  }
};

var DocumentUploadModal = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(DocumentUploadModal, _Component);

  function DocumentUploadModal() {
    _classCallCheck(this, DocumentUploadModal);

    return _possibleConstructorReturn(this, (DocumentUploadModal.__proto__ || Object.getPrototypeOf(DocumentUploadModal)).apply(this, arguments));
  }

  _createClass(DocumentUploadModal, [{
    key: 'fieldSets',
    value: function fieldSets() {
      var _props = this.props,
          showDocumentTypes = _props.showDocumentTypes,
          _document = _props._document,
          fields = [];


      fields.push(FIELDS.name);

      if (showDocumentTypes) {
        fields.push(FIELDS.type);
      }

      if (!_document) {
        fields.push(FIELDS.file);
      }

      return [fields];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _document = _props2._document,
          onClose = _props2.onClose,
          onSubmit = _props2.onSubmit;


      return _react2.default.createElement(_mightyFields.FormModal, {
        className: 'modal-document-upload',
        fieldSets: this.fieldSets(),
        model: _document,
        onClose: onClose,
        onSave: onSubmit,
        title: 'Document'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DocumentUploadModal;
}(_react.Component), _class2.defaultProps = {
  showDocumentTypes: false
}, _class2.propTypes = {
  _document: _propTypes2.default.object,
  onClose: _propTypes2.default.func.isRequired,
  onSubmit: _propTypes2.default.func.isRequired,
  showDocumentTypes: _propTypes2.default.bool
}, _temp)) || _class) || _class;

var _default = DocumentUploadModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FIELDS, 'FIELDS', '/app/src/components/common/DocumentUploadModal.js');
  reactHotLoader.register(DocumentUploadModal, 'DocumentUploadModal', '/app/src/components/common/DocumentUploadModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common/DocumentUploadModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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